import _ from 'lodash';
import React from 'react';
import { useChangeAwareEffect } from 'use-change-aware-effect';
import { Container, FullWidthContentContainer } from '../shared/styles';
import useGetFundAssetClasses from '../../../services/lwadmin/fund-asset-class/fund-asset-class-service';
import { useGetFundCategories } from '../../../services/lwadmin/data-provider/fund-category-service';
import useStore from './manage-categories-components/store-hook';
import Header from './manage-categories-components/header';
import Category from './manage-categories-components/category';

export default function ManageCategories() {
  const categories = useStore(state => state.categories);
  const set = useStore(state => state.set);

  const [, getAssetClasses] = useGetFundAssetClasses();
  const [, getCategories] = useGetFundCategories();

  const onAssetClassesData = React.useCallback(({ data }) => {
    const assetClasses = _.get(data, 'fundAssetClasses', []);
    const mappedAssetClasses = assetClasses.map(a => ({ label: a.name, value: a.id.toString() }));

    set(state => {
      state.assetClasses = mappedAssetClasses;
    });
  }, [set]);

  const onCategoriesData = React.useCallback(({ data }) => {
    set(state => {
      state.categories = _.get(data, 'categories', []);
    });
  }, [set]);

  useChangeAwareEffect(({ isMount }) => {
    if (!isMount) {
      return;
    }

    getAssetClasses().then(onAssetClassesData);
    getCategories().then(onCategoriesData);
  }, {});

  return (
    <Container>
      <FullWidthContentContainer>
        <h1>Manage Data Provider Fund Categories</h1>
        <Header />
        {categories.map(category => <Category key={category.id} category={category} />)}
      </FullWidthContentContainer>
    </Container>
  );
}
